import httpRequest from "utils/httpRequest";
const URL = "/api";

export const getWeather = async (group_id) => {
  const requestBody = {
    group_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/getWeather`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getGroupControlInfo = async (group_id) => {
  const requestBody = {
    group_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/getGroupControlInfo`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getControllerIdList = async (group_id) => {
  const requestBody = {
    group_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/getControllerIdList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getChList = async (bsd_id) => {    // 240129 by LEE,
  const requestBody = {
    bsd_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/selectChList`, requestBody); // Fix: Change to the correct endpoint
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getBsdList = async (e_line, cur_page, group_id) => {
  const requestBody = {
    e_line,
    cur_page,
    group_id,
  };
  try {
    //const response = await httpRequest("post", `${URL}/selectBsdList`, requestBody); // Fix: Change to the correct endpoint/
    const response = await httpRequest("post", `${URL}/selectDeviceList`, requestBody); // Fix: Change to the correct endpoint
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getDeviceList = async (e_line, cur_page, group_id) => {
  const requestBody = {
    e_line,
    cur_page,
    group_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/selectDeviceList`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getMapData = async (e_line, cur_page, group_id) => {
  const requestBody = {
    e_line,
    cur_page,
    group_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/getMapData`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getDevice = async (bsd_id) => {
  const requestBody = {
    bsd_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/selectDeviceInfo`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const getStatusControlList = async () => {
  try {
    const response = await httpRequest("post", `${URL}/newCtrlSttusList`);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const insertDevice = async (data, controlList, statusList, address) => {
  const requestBody = {
    info: {
      bsd_nm: data.bsd_nm,
      manage_instt_id: "",
      cntlr_id: data.cntlr_id,
      map_xcord: Number(data.map_xcord),
      map_ycord: Number(data.map_ycord),
      makr_nm: data.makr_nm,
      model_nm: data.model_nm,
      instl_lc: data.instl_lc != null ? data.instl_lc : "",
      instl_lc_abrv: data.instl_lc != null ? data.instl_lc : "",
      rm: data.rm,
      group_id: data.group_id,
      device_ip: data.device_ip,
    },
    ctrl: controlList.map(({ feedback_ch, ...item }) => ({
      ...item,
      feedback_ch_def: feedback_ch,
    })),
    sttus: statusList,
  };
  try {
    const response = await httpRequest("post", `${URL}/insertDeviceInfo`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateDeviceInfo = async (data, bsd_id, controlList, statusList, address) => {
  const requestBody = {
    info: {
      bsd_id,
      bsd_nm: data.bsd_nm,
      manage_instt_id: "",
      cntlr_id: data.cntlr_id,
      map_xcord: data.map_xcord,
      map_ycord: data.map_ycord,
      makr_nm: data.makr_nm,
      model_nm: data.model_nm,
      instl_lc: address ? address : data.instl_lc,
      instl_lc_abrv: address ? address : data.instl_lc_abrv,
      rm: data.rm,
      group_id: data.group_id,
      device_ip: data.device_ip,
    },
    ctrl: controlList,
    sttus: statusList,
  };

  try {
    const response = await httpRequest("post", `${URL}/updateDeviceInfo`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};

export const deleteDevice = async (bsd_id) => {
  const requestBody = {
    bsd_id,
  };
  try {
    const response = await httpRequest("post", `${URL}/deleteDevice`, requestBody);
    return response;
  } catch (error) {
    console.error(error);
  }
};
export const updateBatchControl = async (ctrllist) => {
    const requestBody = {
      ctrl: ctrllist,
    };
    try {
      const response = await httpRequest("post", `${URL}/updateBatchControl`, requestBody);
      return response;
    } catch (error) {
      console.error(error);
    }
};
